module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/faq/faq.component.css
// module id = ./src/app/faq/faq.component.css
// module chunks = main